import styled from "styled-components";
import Card from "@mui/material/Card";

export const Container = styled(Card)`
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: min(520px, calc(100vw - 32px));
    max-width: min(520px, calc(100vw - 32px));
    max-height: 90vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 20px 24px 24px;
    color: #000000;
    border: 2px solid #f5f5f5;
    outline: none;
`;

export const FormContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    margin: 0;
`;
